import { render, staticRenderFns } from "./GB.vue?vue&type=template&id=4b7eb9a8&scoped=true&"
import script from "./GB.vue?vue&type=script&lang=js&"
export * from "./GB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7eb9a8",
  null
  
)

export default component.exports